import { getAmpClientId } from '../../utils.js';
import createMemoizedFunction from '../../../node_modules/micro-memoize/dist/micro-memoize.esm.js';

var commonClientMetadataAmpAdjacent = createMemoizedFunction(function () {
  let {
    track_amp = false,
    ...options
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (!track_amp) {
    // If track_amp is false, return empty layer data
    return {};
  }
  return createMemoizedFunction(() => ({
    amp_id: getAmpClientId(options)
  }), {
    transformKey: JSON.stringify
  });
}, {
  transformKey: JSON.stringify
});

export default commonClientMetadataAmpAdjacent;
